export default {
    "RECORDS": [
        {
            "ID": "1011",
            "CODE": "石灰石、石膏开采",
            "TOP_ID": "B"
        },
        {
            "ID": "1012",
            "CODE": "建筑装饰用石开采",
            "TOP_ID": "B"
        },
        {
            "ID": "1013",
            "CODE": "耐火土石开采",
            "TOP_ID": "B"
        },
        {
            "ID": "1019",
            "CODE": "粘土及其他土砂石开采",
            "TOP_ID": "B"
        },
        {
            "ID": "1020",
            "CODE": "化学矿开采",
            "TOP_ID": "B"
        },
        {
            "ID": "1030",
            "CODE": "采盐",
            "TOP_ID": "B"
        },
        {
            "ID": "1091",
            "CODE": "石棉、云母矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "1092",
            "CODE": "石墨、滑石采选",
            "TOP_ID": "B"
        },
        {
            "ID": "1093",
            "CODE": "宝石、玉石采选",
            "TOP_ID": "B"
        },
        {
            "ID": "1099",
            "CODE": "其他未列明非金属矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "111",
            "CODE": "稻谷种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1110",
            "CODE": "煤炭开采和洗选辅助活动",
            "TOP_ID": "B"
        },
        {
            "ID": "112",
            "CODE": "小麦种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1120",
            "CODE": "石油和天然气开采辅助活动",
            "TOP_ID": "B"
        },
        {
            "ID": "113",
            "CODE": "玉米种植",
            "TOP_ID": "A"
        },
        {
            "ID": "119",
            "CODE": "其他谷物种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1190",
            "CODE": "其他开采辅助活动",
            "TOP_ID": "B"
        },
        {
            "ID": "1200",
            "CODE": "其他采矿业",
            "TOP_ID": "B"
        },
        {
            "ID": "121",
            "CODE": "豆类种植",
            "TOP_ID": "A"
        },
        {
            "ID": "122",
            "CODE": "油料种植",
            "TOP_ID": "A"
        },
        {
            "ID": "123",
            "CODE": "薯类种植",
            "TOP_ID": "A"
        },
        {
            "ID": "131",
            "CODE": "棉花种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1310",
            "CODE": "谷物磨制",
            "TOP_ID": "C"
        },
        {
            "ID": "132",
            "CODE": "麻类种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1320",
            "CODE": "饲料加工",
            "TOP_ID": "C"
        },
        {
            "ID": "133",
            "CODE": "糖料种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1331",
            "CODE": "食用植物油加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1332",
            "CODE": "非食用植物油加工",
            "TOP_ID": "C"
        },
        {
            "ID": "134",
            "CODE": "烟草种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1340",
            "CODE": "制糖业",
            "TOP_ID": "C"
        },
        {
            "ID": "1351",
            "CODE": "牲畜屠宰",
            "TOP_ID": "C"
        },
        {
            "ID": "1352",
            "CODE": "禽类屠宰",
            "TOP_ID": "C"
        },
        {
            "ID": "1353",
            "CODE": "肉制品及副产品加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1361",
            "CODE": "水产品冷冻加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1362",
            "CODE": "鱼糜制品及水产品干腌制加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1363",
            "CODE": "水产饲料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1364",
            "CODE": "鱼油提取及制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1369",
            "CODE": "其他水产品加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1371",
            "CODE": "蔬菜加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1372",
            "CODE": "水果和坚果加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1391",
            "CODE": "淀粉及淀粉制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1392",
            "CODE": "豆制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1393",
            "CODE": "蛋品加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1399",
            "CODE": "其他未列明农副食品加工",
            "TOP_ID": "C"
        },
        {
            "ID": "141",
            "CODE": "蔬菜种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1411",
            "CODE": "糕点、面包制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1419",
            "CODE": "饼干及其他焙烤食品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "142",
            "CODE": "食用菌种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1421",
            "CODE": "糖果、巧克力制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1422",
            "CODE": "蜜饯制作",
            "TOP_ID": "C"
        },
        {
            "ID": "143",
            "CODE": "花卉种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1431",
            "CODE": "米、面制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1432",
            "CODE": "速冻食品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1439",
            "CODE": "方便面及其他方便食品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1440",
            "CODE": "乳制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1451",
            "CODE": "肉、禽类罐头制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1452",
            "CODE": "水产品罐头制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1453",
            "CODE": "蔬菜、水果罐头制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1459",
            "CODE": "其他罐头食品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1461",
            "CODE": "味精制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1462",
            "CODE": "酱油、食醋及类似制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1469",
            "CODE": "其他调味品、发酵制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "149",
            "CODE": "其他园艺作物种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1491",
            "CODE": "营养食品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1492",
            "CODE": "保健食品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1493",
            "CODE": "冷冻饮品及食用冰制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1494",
            "CODE": "盐加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1495",
            "CODE": "食品及饲料添加剂制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1499",
            "CODE": "其他未列明食品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "151",
            "CODE": "仁果类和核果类水果种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1511",
            "CODE": "酒精制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1512",
            "CODE": "白酒制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1513",
            "CODE": "啤酒制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1514",
            "CODE": "黄酒制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1515",
            "CODE": "葡萄酒制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1519",
            "CODE": "其他酒制造",
            "TOP_ID": "C"
        },
        {
            "ID": "152",
            "CODE": "葡萄种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1521",
            "CODE": "碳酸饮料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1522",
            "CODE": "瓶（罐）装饮用水制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1523",
            "CODE": "果菜汁及果菜汁饮料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1524",
            "CODE": "含乳饮料和植物蛋白饮料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1525",
            "CODE": "固体饮料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1529",
            "CODE": "茶饮料及其他饮料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "153",
            "CODE": "柑橘类种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1530",
            "CODE": "精制茶加工",
            "TOP_ID": "C"
        },
        {
            "ID": "154",
            "CODE": "香蕉等亚热带水果种植",
            "TOP_ID": "A"
        },
        {
            "ID": "159",
            "CODE": "其他水果种植",
            "TOP_ID": "A"
        },
        {
            "ID": "161",
            "CODE": "坚果种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1610",
            "CODE": "烟叶复烤",
            "TOP_ID": "C"
        },
        {
            "ID": "162",
            "CODE": "含油果种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1620",
            "CODE": "卷烟制造",
            "TOP_ID": "C"
        },
        {
            "ID": "163",
            "CODE": "香料作物种植",
            "TOP_ID": "A"
        },
        {
            "ID": "169",
            "CODE": "茶及其他饮料作物种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1690",
            "CODE": "其他烟草制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "170",
            "CODE": "中药材种植",
            "TOP_ID": "A"
        },
        {
            "ID": "1711",
            "CODE": "棉纺纱加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1712",
            "CODE": "棉织造加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1713",
            "CODE": "棉印染精加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1721",
            "CODE": "毛条和毛纱线加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1722",
            "CODE": "毛织造加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1723",
            "CODE": "毛染整精加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1731",
            "CODE": "麻纤维纺前加工和纺纱",
            "TOP_ID": "C"
        },
        {
            "ID": "1732",
            "CODE": "麻织造加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1733",
            "CODE": "麻染整精加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1741",
            "CODE": "缫丝加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1742",
            "CODE": "绢纺和丝织加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1743",
            "CODE": "丝印染精加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1751",
            "CODE": "化纤织造加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1752",
            "CODE": "化纤织物染整精加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1761",
            "CODE": "针织或钩针编织物织造",
            "TOP_ID": "C"
        },
        {
            "ID": "1762",
            "CODE": "针织或钩针编织物印染精加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1763",
            "CODE": "针织或钩针编织品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1771",
            "CODE": "床上用品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1772",
            "CODE": "毛巾类制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1773",
            "CODE": "窗帘、布艺类产品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1779",
            "CODE": "其他家用纺织制成品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1781",
            "CODE": "非织造布制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1782",
            "CODE": "绳、索、缆制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1783",
            "CODE": "纺织带和帘子布制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1784",
            "CODE": "篷、帆布制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1789",
            "CODE": "其他非家用纺织制成品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1810",
            "CODE": "机织服装制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1820",
            "CODE": "针织或钩针编织服装制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1830",
            "CODE": "服饰制造",
            "TOP_ID": "C"
        },
        {
            "ID": "190",
            "CODE": "其他农业",
            "TOP_ID": "A"
        },
        {
            "ID": "1910",
            "CODE": "皮革鞣制加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1921",
            "CODE": "皮革服装制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1922",
            "CODE": "皮箱、包（袋）制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1923",
            "CODE": "皮手套及皮装饰制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1929",
            "CODE": "其他皮革制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1931",
            "CODE": "毛皮鞣制加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1932",
            "CODE": "毛皮服装加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1939",
            "CODE": "其他毛皮制品加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1941",
            "CODE": "羽毛（绒）加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1942",
            "CODE": "羽毛（绒）制品加工",
            "TOP_ID": "C"
        },
        {
            "ID": "1951",
            "CODE": "纺织面料鞋制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1952",
            "CODE": "皮鞋制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1953",
            "CODE": "塑料鞋制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1954",
            "CODE": "橡胶鞋制造",
            "TOP_ID": "C"
        },
        {
            "ID": "1959",
            "CODE": "其他制鞋业",
            "TOP_ID": "C"
        },
        {
            "ID": "2011",
            "CODE": "锯材加工",
            "TOP_ID": "C"
        },
        {
            "ID": "2012",
            "CODE": "木片加工",
            "TOP_ID": "C"
        },
        {
            "ID": "2013",
            "CODE": "单板加工",
            "TOP_ID": "C"
        },
        {
            "ID": "2019",
            "CODE": "其他木材加工",
            "TOP_ID": "C"
        },
        {
            "ID": "2021",
            "CODE": "胶合板制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2022",
            "CODE": "纤维板制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2023",
            "CODE": "刨花板制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2029",
            "CODE": "其他人造板制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2031",
            "CODE": "建筑用木料及木材组件加工",
            "TOP_ID": "C"
        },
        {
            "ID": "2032",
            "CODE": "木门窗、楼梯制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2033",
            "CODE": "地板制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2034",
            "CODE": "木制容器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2039",
            "CODE": "软木制品及其他木制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2041",
            "CODE": "竹制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2042",
            "CODE": "藤制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2043",
            "CODE": "棕制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2049",
            "CODE": "草及其他制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "211",
            "CODE": "林木育种",
            "TOP_ID": "A"
        },
        {
            "ID": "2110",
            "CODE": "木质家具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "212",
            "CODE": "林木育苗",
            "TOP_ID": "A"
        },
        {
            "ID": "2120",
            "CODE": "竹、藤家具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2130",
            "CODE": "金属家具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2140",
            "CODE": "塑料家具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2190",
            "CODE": "其他家具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "220",
            "CODE": "造林和更新",
            "TOP_ID": "A"
        },
        {
            "ID": "2211",
            "CODE": "木竹浆制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2212",
            "CODE": "非木竹浆制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2221",
            "CODE": "机制纸及纸板制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2222",
            "CODE": "手工纸制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2223",
            "CODE": "加工纸制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2231",
            "CODE": "纸和纸板容器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2239",
            "CODE": "其他纸制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "230",
            "CODE": "森林经营和管护",
            "TOP_ID": "A"
        },
        {
            "ID": "2311",
            "CODE": "书、报刊印刷",
            "TOP_ID": "C"
        },
        {
            "ID": "2312",
            "CODE": "本册印制",
            "TOP_ID": "C"
        },
        {
            "ID": "2319",
            "CODE": "包装装潢及其他印刷",
            "TOP_ID": "C"
        },
        {
            "ID": "2320",
            "CODE": "装订及印刷相关服务",
            "TOP_ID": "C"
        },
        {
            "ID": "2330",
            "CODE": "记录媒介复制",
            "TOP_ID": "C"
        },
        {
            "ID": "241",
            "CODE": "木材采运",
            "TOP_ID": "A"
        },
        {
            "ID": "2411",
            "CODE": "文具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2412",
            "CODE": "笔的制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2413",
            "CODE": "教学用模型及教具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2414",
            "CODE": "墨水、墨汁制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2419",
            "CODE": "其他文教办公用品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "242",
            "CODE": "竹材采运",
            "TOP_ID": "A"
        },
        {
            "ID": "2421",
            "CODE": "中乐器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2422",
            "CODE": "西乐器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2423",
            "CODE": "电子乐器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2429",
            "CODE": "其他乐器及零件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2431",
            "CODE": "雕塑工艺品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2432",
            "CODE": "金属工艺品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2433",
            "CODE": "漆器工艺品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2434",
            "CODE": "花画工艺品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2435",
            "CODE": "天然植物纤维编织工艺品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2436",
            "CODE": "抽纱刺绣工艺品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2437",
            "CODE": "地毯、挂毯制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2438",
            "CODE": "珠宝首饰及有关物品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2439",
            "CODE": "其他工艺美术品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2441",
            "CODE": "球类制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2442",
            "CODE": "体育器材及配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2443",
            "CODE": "训练健身器材制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2444",
            "CODE": "运动防护用具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2449",
            "CODE": "其他体育用品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2450",
            "CODE": "玩具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2461",
            "CODE": "露天游乐场所游乐设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2462",
            "CODE": "游艺用品及室内游艺器材制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2469",
            "CODE": "其他娱乐用品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "251",
            "CODE": "木竹材林产品采集",
            "TOP_ID": "A"
        },
        {
            "ID": "2511",
            "CODE": "原油加工及石油制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2512",
            "CODE": "人造原油制造",
            "TOP_ID": "C"
        },
        {
            "ID": "252",
            "CODE": "非木竹材林产品采集",
            "TOP_ID": "A"
        },
        {
            "ID": "2520",
            "CODE": "炼焦",
            "TOP_ID": "C"
        },
        {
            "ID": "2530",
            "CODE": "核燃料加工",
            "TOP_ID": "C"
        },
        {
            "ID": "2611",
            "CODE": "无机酸制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2612",
            "CODE": "无机碱制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2613",
            "CODE": "无机盐制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2614",
            "CODE": "有机化学原料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2619",
            "CODE": "其他基础化学原料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2621",
            "CODE": "氮肥制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2622",
            "CODE": "磷肥制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2623",
            "CODE": "钾肥制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2624",
            "CODE": "复混肥料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2625",
            "CODE": "有机肥料及微生物肥料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2629",
            "CODE": "其他肥料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2631",
            "CODE": "化学农药制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2632",
            "CODE": "生物化学农药及微生物农药制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2641",
            "CODE": "涂料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2642",
            "CODE": "油墨及类似产品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2643",
            "CODE": "颜料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2644",
            "CODE": "染料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2645",
            "CODE": "密封用填料及类似品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2651",
            "CODE": "初级形态塑料及合成树脂制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2652",
            "CODE": "合成橡胶制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2653",
            "CODE": "合成纤维单（聚合）体制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2659",
            "CODE": "其他合成材料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2661",
            "CODE": "化学试剂和助剂制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2662",
            "CODE": "专项化学用品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2663",
            "CODE": "林产化学产品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2664",
            "CODE": "信息化学品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2665",
            "CODE": "环境污染处理专用药剂材料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2666",
            "CODE": "动物胶制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2669",
            "CODE": "其他专用化学产品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2671",
            "CODE": "炸药及火工产品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2672",
            "CODE": "焰火、鞭炮产品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2681",
            "CODE": "肥皂及合成洗涤剂制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2682",
            "CODE": "化妆品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2683",
            "CODE": "口腔清洁用品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2684",
            "CODE": "香料、香精制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2689",
            "CODE": "其他日用化学产品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2710",
            "CODE": "化学药品原料药制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2720",
            "CODE": "化学药品制剂制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2730",
            "CODE": "中药饮片加工",
            "TOP_ID": "C"
        },
        {
            "ID": "2740",
            "CODE": "中成药生产",
            "TOP_ID": "C"
        },
        {
            "ID": "2750",
            "CODE": "兽用药品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2760",
            "CODE": "生物药品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2770",
            "CODE": "卫生材料及医药用品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2811",
            "CODE": "化纤浆粕制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2812",
            "CODE": "人造纤维（纤维素纤维）制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2821",
            "CODE": "锦纶纤维制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2822",
            "CODE": "涤纶纤维制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2823",
            "CODE": "腈纶纤维制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2824",
            "CODE": "维纶纤维制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2825",
            "CODE": "丙纶纤维制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2826",
            "CODE": "氨纶纤维制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2829",
            "CODE": "其他合成纤维制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2911",
            "CODE": "轮胎制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2912",
            "CODE": "橡胶板、管、带制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2913",
            "CODE": "橡胶零件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2914",
            "CODE": "再生橡胶制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2915",
            "CODE": "日用及医用橡胶制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2919",
            "CODE": "其他橡胶制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2921",
            "CODE": "塑料薄膜制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2922",
            "CODE": "塑料板、管、型材制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2923",
            "CODE": "塑料丝、绳及编织品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2924",
            "CODE": "泡沫塑料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2925",
            "CODE": "塑料人造革、合成革制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2926",
            "CODE": "塑料包装箱及容器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2927",
            "CODE": "日用塑料制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2928",
            "CODE": "塑料零件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "2929",
            "CODE": "其他塑料制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3011",
            "CODE": "水泥制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3012",
            "CODE": "石灰和石膏制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3021",
            "CODE": "水泥制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3022",
            "CODE": "砼结构构件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3023",
            "CODE": "石棉水泥制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3024",
            "CODE": "轻质建筑材料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3029",
            "CODE": "其他水泥类似制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3031",
            "CODE": "粘土砖瓦及建筑砌块制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3032",
            "CODE": "建筑陶瓷制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3033",
            "CODE": "建筑用石加工",
            "TOP_ID": "C"
        },
        {
            "ID": "3034",
            "CODE": "防水建筑材料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3035",
            "CODE": "隔热和隔音材料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3039",
            "CODE": "其他建筑材料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3041",
            "CODE": "平板玻璃制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3049",
            "CODE": "其他玻璃制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3051",
            "CODE": "技术玻璃制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3052",
            "CODE": "光学玻璃制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3053",
            "CODE": "玻璃仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3054",
            "CODE": "日用玻璃制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3055",
            "CODE": "玻璃包装容器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3056",
            "CODE": "玻璃保温容器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3057",
            "CODE": "制镜及类似品加工",
            "TOP_ID": "C"
        },
        {
            "ID": "3059",
            "CODE": "其他玻璃制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3061",
            "CODE": "玻璃纤维及制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3062",
            "CODE": "玻璃纤维增强塑料制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3071",
            "CODE": "卫生陶瓷制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3072",
            "CODE": "特种陶瓷制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3073",
            "CODE": "日用陶瓷制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3079",
            "CODE": "园林、陈设艺术及其他陶瓷制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3081",
            "CODE": "石棉制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3082",
            "CODE": "云母制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3089",
            "CODE": "耐火陶瓷制品及其他耐火材料制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3091",
            "CODE": "石墨及碳素制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3099",
            "CODE": "其他非金属矿物制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "311",
            "CODE": "牛的饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "3110",
            "CODE": "炼铁",
            "TOP_ID": "C"
        },
        {
            "ID": "312",
            "CODE": "马的饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "3120",
            "CODE": "炼钢",
            "TOP_ID": "C"
        },
        {
            "ID": "313",
            "CODE": "猪的饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "3130",
            "CODE": "黑色金属铸造",
            "TOP_ID": "C"
        },
        {
            "ID": "314",
            "CODE": "羊的饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "3140",
            "CODE": "钢压延加工",
            "TOP_ID": "C"
        },
        {
            "ID": "315",
            "CODE": "骆驼饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "3150",
            "CODE": "铁合金冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "319",
            "CODE": "其他牲畜饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "321",
            "CODE": "鸡的饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "3211",
            "CODE": "铜冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3212",
            "CODE": "铅锌冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3213",
            "CODE": "镍钴冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3214",
            "CODE": "锡冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3215",
            "CODE": "锑冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3216",
            "CODE": "铝冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3217",
            "CODE": "镁冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3219",
            "CODE": "其他常用有色金属冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "322",
            "CODE": "鸭的饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "3221",
            "CODE": "金冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3222",
            "CODE": "银冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3229",
            "CODE": "其他贵金属冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "323",
            "CODE": "鹅的饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "3231",
            "CODE": "钨钼冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3232",
            "CODE": "稀土金属冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3239",
            "CODE": "其他稀有金属冶炼",
            "TOP_ID": "C"
        },
        {
            "ID": "3240",
            "CODE": "有色金属合金制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3250",
            "CODE": "有色金属铸造",
            "TOP_ID": "C"
        },
        {
            "ID": "3261",
            "CODE": "铜压延加工",
            "TOP_ID": "C"
        },
        {
            "ID": "3262",
            "CODE": "铝压延加工",
            "TOP_ID": "C"
        },
        {
            "ID": "3263",
            "CODE": "贵金属压延加工",
            "TOP_ID": "C"
        },
        {
            "ID": "3264",
            "CODE": "稀有稀土金属压延加工",
            "TOP_ID": "C"
        },
        {
            "ID": "3269",
            "CODE": "其他有色金属压延加工",
            "TOP_ID": "C"
        },
        {
            "ID": "329",
            "CODE": "其他家禽饲养",
            "TOP_ID": "A"
        },
        {
            "ID": "330",
            "CODE": "狩猎和捕捉动物",
            "TOP_ID": "A"
        },
        {
            "ID": "3311",
            "CODE": "金属结构制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3312",
            "CODE": "金属门窗制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3321",
            "CODE": "切削工具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3322",
            "CODE": "手工具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3323",
            "CODE": "农用及园林用金属工具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3324",
            "CODE": "刀剪及类似日用金属工具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3329",
            "CODE": "其他金属工具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3331",
            "CODE": "集装箱制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3332",
            "CODE": "金属压力容器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3333",
            "CODE": "金属包装容器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3340",
            "CODE": "金属丝绳及其制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3351",
            "CODE": "建筑、家具用金属配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3352",
            "CODE": "建筑装饰及水暖管道零件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3353",
            "CODE": "安全、消防用金属制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3359",
            "CODE": "其他建筑、安全用金属制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3360",
            "CODE": "金属表面处理及热处理加工",
            "TOP_ID": "C"
        },
        {
            "ID": "3371",
            "CODE": "生产专用搪瓷制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3372",
            "CODE": "建筑装饰搪瓷制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3373",
            "CODE": "搪瓷卫生洁具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3379",
            "CODE": "搪瓷日用品及其他搪瓷制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3381",
            "CODE": "金属制厨房用器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3382",
            "CODE": "金属制餐具和器皿制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3383",
            "CODE": "金属制卫生器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3389",
            "CODE": "其他金属制日用品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3391",
            "CODE": "锻件及粉末冶金制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3392",
            "CODE": "交通及公共管理用金属标牌制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3399",
            "CODE": "其他未列明金属制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3411",
            "CODE": "锅炉及辅助设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3412",
            "CODE": "内燃机及配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3413",
            "CODE": "汽轮机及辅机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3414",
            "CODE": "水轮机及辅机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3415",
            "CODE": "风能原动设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3419",
            "CODE": "其他原动设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3421",
            "CODE": "金属切削机床制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3422",
            "CODE": "金属成形机床制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3423",
            "CODE": "铸造机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3424",
            "CODE": "金属切割及焊接设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3425",
            "CODE": "机床附件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3429",
            "CODE": "其他金属加工机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3431",
            "CODE": "轻小型起重设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3432",
            "CODE": "起重机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3433",
            "CODE": "生产专用车辆制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3434",
            "CODE": "连续搬运设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3435",
            "CODE": "电梯、自动扶梯及升降机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3439",
            "CODE": "其他物料搬运设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3441",
            "CODE": "泵及真空设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3442",
            "CODE": "气体压缩机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3443",
            "CODE": "阀门和旋塞制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3444",
            "CODE": "液压和气压动力机械及元件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3451",
            "CODE": "轴承制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3452",
            "CODE": "齿轮及齿轮减、变速箱制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3459",
            "CODE": "其他传动部件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3461",
            "CODE": "烘炉、熔炉及电炉制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3462",
            "CODE": "风机、风扇制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3463",
            "CODE": "气体、液体分离及纯净设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3464",
            "CODE": "制冷、空调设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3465",
            "CODE": "风动和电动工具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3466",
            "CODE": "喷枪及类似器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3467",
            "CODE": "衡器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3468",
            "CODE": "包装专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3471",
            "CODE": "电影机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3472",
            "CODE": "幻灯及投影设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3473",
            "CODE": "照相机及器材制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3474",
            "CODE": "复印和胶印设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3475",
            "CODE": "计算器及货币专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3479",
            "CODE": "其他文化、办公用机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3481",
            "CODE": "金属密封件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3482",
            "CODE": "紧固件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3483",
            "CODE": "弹簧制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3484",
            "CODE": "机械零部件加工",
            "TOP_ID": "C"
        },
        {
            "ID": "3489",
            "CODE": "其他通用零部件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3490",
            "CODE": "其他通用设备制造业",
            "TOP_ID": "C"
        },
        {
            "ID": "3511",
            "CODE": "矿山机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3512",
            "CODE": "石油钻采专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3513",
            "CODE": "建筑工程用机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3514",
            "CODE": "海洋工程专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3515",
            "CODE": "建筑材料生产专用机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3516",
            "CODE": "冶金专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3521",
            "CODE": "炼油、化工生产专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3522",
            "CODE": "橡胶加工专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3523",
            "CODE": "塑料加工专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3524",
            "CODE": "木材加工机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3525",
            "CODE": "模具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3529",
            "CODE": "其他非金属加工专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3531",
            "CODE": "食品、酒、饮料及茶生产专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3532",
            "CODE": "农副食品加工专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3533",
            "CODE": "烟草生产专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3534",
            "CODE": "饲料生产专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3541",
            "CODE": "制浆和造纸专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3542",
            "CODE": "印刷专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3543",
            "CODE": "日用化工专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3544",
            "CODE": "制药专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3545",
            "CODE": "照明器具生产专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3546",
            "CODE": "玻璃、陶瓷和搪瓷制品生产专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3549",
            "CODE": "其他日用品生产专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3551",
            "CODE": "纺织专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3552",
            "CODE": "皮革、毛皮及其制品加工专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3553",
            "CODE": "缝制机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3554",
            "CODE": "洗涤机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3561",
            "CODE": "电工机械专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3562",
            "CODE": "电子工业专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3571",
            "CODE": "拖拉机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3572",
            "CODE": "机械化农业及园艺机具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3573",
            "CODE": "营林及木竹采伐机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3574",
            "CODE": "畜牧机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3575",
            "CODE": "渔业机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3576",
            "CODE": "农林牧渔机械配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3577",
            "CODE": "棉花加工机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3579",
            "CODE": "其他农、林、牧、渔业机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3581",
            "CODE": "医疗诊断、监护及治疗设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3582",
            "CODE": "口腔科用设备及器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3583",
            "CODE": "医疗实验室及医用消毒设备和器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3584",
            "CODE": "医疗、外科及兽医用器械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3585",
            "CODE": "机械治疗及病房护理设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3586",
            "CODE": "假肢、人工器官及植（介）入器械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3589",
            "CODE": "其他医疗设备及器械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3591",
            "CODE": "环境保护专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3592",
            "CODE": "地质勘查专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3593",
            "CODE": "邮政专用机械及器材制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3594",
            "CODE": "商业、饮食、服务专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3595",
            "CODE": "社会公共安全设备及器材制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3596",
            "CODE": "交通安全、管制及类似专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3597",
            "CODE": "水资源专用机械制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3599",
            "CODE": "其他专用设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3610",
            "CODE": "汽车整车制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3620",
            "CODE": "改装汽车制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3630",
            "CODE": "低速载货汽车制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3640",
            "CODE": "电车制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3650",
            "CODE": "汽车车身、挂车制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3660",
            "CODE": "汽车零部件及配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3711",
            "CODE": "铁路机车车辆及动车组制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3712",
            "CODE": "窄轨机车车辆制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3713",
            "CODE": "铁路机车车辆配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3714",
            "CODE": "铁路专用设备及器材、配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3719",
            "CODE": "其他铁路运输设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3720",
            "CODE": "城市轨道交通设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3731",
            "CODE": "金属船舶制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3732",
            "CODE": "非金属船舶制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3733",
            "CODE": "娱乐船和运动船制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3734",
            "CODE": "船用配套设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3735",
            "CODE": "船舶改装与拆除",
            "TOP_ID": "C"
        },
        {
            "ID": "3739",
            "CODE": "航标器材及其他相关装置制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3741",
            "CODE": "飞机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3742",
            "CODE": "航天器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3743",
            "CODE": "航空、航天相关设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3749",
            "CODE": "其他航空航天器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3751",
            "CODE": "摩托车整车制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3752",
            "CODE": "摩托车零部件及配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3761",
            "CODE": "脚踏自行车及残疾人座车制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3762",
            "CODE": "助动自行车制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3770",
            "CODE": "非公路休闲车及零配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3791",
            "CODE": "潜水及水下救捞装备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3799",
            "CODE": "其他未列明运输设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3811",
            "CODE": "发电机及发电机组制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3812",
            "CODE": "电动机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3819",
            "CODE": "微电机及其他电机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3821",
            "CODE": "变压器、整流器和电感器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3822",
            "CODE": "电容器及其配套设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3823",
            "CODE": "配电开关控制设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3824",
            "CODE": "电力电子元器件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3825",
            "CODE": "光伏设备及元器件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3829",
            "CODE": "其他输配电及控制设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3831",
            "CODE": "电线、电缆制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3832",
            "CODE": "光纤、光缆制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3833",
            "CODE": "绝缘制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3839",
            "CODE": "其他电工器材制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3841",
            "CODE": "锂离子电池制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3842",
            "CODE": "镍氢电池制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3849",
            "CODE": "其他电池制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3851",
            "CODE": "家用制冷电器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3852",
            "CODE": "家用空气调节器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3853",
            "CODE": "家用通风电器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3854",
            "CODE": "家用厨房电器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3855",
            "CODE": "家用清洁卫生电器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3856",
            "CODE": "家用美容、保健电器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3857",
            "CODE": "家用电力器具专用配件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3859",
            "CODE": "其他家用电力器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3861",
            "CODE": "燃气、太阳能及类似能源家用器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3869",
            "CODE": "其他非电力家用器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3871",
            "CODE": "电光源制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3872",
            "CODE": "照明灯具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3879",
            "CODE": "灯用电器附件及其他照明器具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3891",
            "CODE": "电气信号设备装置制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3899",
            "CODE": "其他未列明电气机械及器材制造",
            "TOP_ID": "C"
        },
        {
            "ID": "390",
            "CODE": "其他畜牧业",
            "TOP_ID": "A"
        },
        {
            "ID": "3911",
            "CODE": "计算机整机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3912",
            "CODE": "计算机零部件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3913",
            "CODE": "计算机外围设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3919",
            "CODE": "其他计算机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3921",
            "CODE": "通信系统设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3922",
            "CODE": "通信终端设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3931",
            "CODE": "广播电视节目制作及发射设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3932",
            "CODE": "广播电视接收设备及器材制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3939",
            "CODE": "应用电视设备及其他广播电视设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3940",
            "CODE": "雷达及配套设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3951",
            "CODE": "电视机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3952",
            "CODE": "音响设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3953",
            "CODE": "影视录放设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3961",
            "CODE": "电子真空器件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3962",
            "CODE": "半导体分立器件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3963",
            "CODE": "集成电路制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3969",
            "CODE": "光电子器件及其他电子器件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3971",
            "CODE": "电子元件及组件制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3972",
            "CODE": "印制电路板制造",
            "TOP_ID": "C"
        },
        {
            "ID": "3990",
            "CODE": "其他电子设备制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4011",
            "CODE": "工业自动控制系统装置制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4012",
            "CODE": "电工仪器仪表制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4013",
            "CODE": "绘图、计算及测量仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4014",
            "CODE": "实验分析仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4015",
            "CODE": "试验机制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4019",
            "CODE": "供应用仪表及其他通用仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4021",
            "CODE": "环境监测专用仪器仪表制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4022",
            "CODE": "运输设备及生产用计数仪表制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4023",
            "CODE": "导航、气象及海洋专用仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4024",
            "CODE": "农林牧渔专用仪器仪表制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4025",
            "CODE": "地质勘探和地震专用仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4026",
            "CODE": "教学专用仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4027",
            "CODE": "核子及核辐射测量仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4028",
            "CODE": "电子测量仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4029",
            "CODE": "其他专用仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4030",
            "CODE": "钟表与计时仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4041",
            "CODE": "光学仪器制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4042",
            "CODE": "眼镜制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4090",
            "CODE": "其他仪器仪表制造业",
            "TOP_ID": "C"
        },
        {
            "ID": "411",
            "CODE": "海水养殖",
            "TOP_ID": "A"
        },
        {
            "ID": "4111",
            "CODE": "鬃毛加工、制刷及清扫工具制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4119",
            "CODE": "其他日用杂品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "412",
            "CODE": "内陆养殖",
            "TOP_ID": "A"
        },
        {
            "ID": "4120",
            "CODE": "煤制品制造",
            "TOP_ID": "C"
        },
        {
            "ID": "4130",
            "CODE": "核辐射加工",
            "TOP_ID": "C"
        },
        {
            "ID": "4190",
            "CODE": "其他未列明制造业",
            "TOP_ID": "C"
        },
        {
            "ID": "421",
            "CODE": "海水捕捞",
            "TOP_ID": "A"
        },
        {
            "ID": "4210",
            "CODE": "金属废料和碎屑加工处理",
            "TOP_ID": "C"
        },
        {
            "ID": "422",
            "CODE": "内陆捕捞",
            "TOP_ID": "A"
        },
        {
            "ID": "4220",
            "CODE": "非金属废料和碎屑加工处理",
            "TOP_ID": "C"
        },
        {
            "ID": "4310",
            "CODE": "金属制品修理",
            "TOP_ID": "C"
        },
        {
            "ID": "4320",
            "CODE": "通用设备修理",
            "TOP_ID": "C"
        },
        {
            "ID": "4330",
            "CODE": "专用设备修理",
            "TOP_ID": "C"
        },
        {
            "ID": "4341",
            "CODE": "铁路运输设备修理",
            "TOP_ID": "C"
        },
        {
            "ID": "4342",
            "CODE": "船舶修理",
            "TOP_ID": "C"
        },
        {
            "ID": "4343",
            "CODE": "航空航天器修理",
            "TOP_ID": "C"
        },
        {
            "ID": "4349",
            "CODE": "其他运输设备修理",
            "TOP_ID": "C"
        },
        {
            "ID": "4350",
            "CODE": "电气设备修理",
            "TOP_ID": "C"
        },
        {
            "ID": "4360",
            "CODE": "仪器仪表修理",
            "TOP_ID": "C"
        },
        {
            "ID": "4390",
            "CODE": "其他机械和设备修理业",
            "TOP_ID": "C"
        },
        {
            "ID": "4411",
            "CODE": "火力发电",
            "TOP_ID": "D"
        },
        {
            "ID": "4412",
            "CODE": "水力发电",
            "TOP_ID": "D"
        },
        {
            "ID": "4413",
            "CODE": "核力发电",
            "TOP_ID": "D"
        },
        {
            "ID": "4414",
            "CODE": "风力发电",
            "TOP_ID": "D"
        },
        {
            "ID": "4415",
            "CODE": "太阳能发电",
            "TOP_ID": "D"
        },
        {
            "ID": "4419",
            "CODE": "其他电力生产",
            "TOP_ID": "D"
        },
        {
            "ID": "4420",
            "CODE": "电力供应",
            "TOP_ID": "D"
        },
        {
            "ID": "4430",
            "CODE": "热力生产和供应",
            "TOP_ID": "D"
        },
        {
            "ID": "4500",
            "CODE": "燃气生产和供应业",
            "TOP_ID": "D"
        },
        {
            "ID": "4610",
            "CODE": "自来水生产和供应",
            "TOP_ID": "D"
        },
        {
            "ID": "4620",
            "CODE": "污水处理及其再生利用",
            "TOP_ID": "D"
        },
        {
            "ID": "4690",
            "CODE": "其他水的处理、利用与分配",
            "TOP_ID": "D"
        },
        {
            "ID": "4700",
            "CODE": "房屋建筑业",
            "TOP_ID": "E"
        },
        {
            "ID": "4811",
            "CODE": "铁路工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4812",
            "CODE": "公路工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4813",
            "CODE": "市政道路工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4819",
            "CODE": "其他道路、隧道和桥梁工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4821",
            "CODE": "水源及供水设施工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4822",
            "CODE": "河湖治理及防洪设施工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4823",
            "CODE": "港口及航运设施工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4830",
            "CODE": "海洋工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4840",
            "CODE": "工矿工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4851",
            "CODE": "架线及设备工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4852",
            "CODE": "管道工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4890",
            "CODE": "其他土木工程建筑",
            "TOP_ID": "E"
        },
        {
            "ID": "4910",
            "CODE": "电气安装",
            "TOP_ID": "E"
        },
        {
            "ID": "4920",
            "CODE": "管道和设备安装",
            "TOP_ID": "E"
        },
        {
            "ID": "4990",
            "CODE": "其他建筑安装业",
            "TOP_ID": "E"
        },
        {
            "ID": "5010",
            "CODE": "建筑装饰业",
            "TOP_ID": "E"
        },
        {
            "ID": "5021",
            "CODE": "建筑物拆除活动",
            "TOP_ID": "E"
        },
        {
            "ID": "5029",
            "CODE": "其他工程准备活动",
            "TOP_ID": "E"
        },
        {
            "ID": "5030",
            "CODE": "提供施工设备服务",
            "TOP_ID": "E"
        },
        {
            "ID": "5090",
            "CODE": "其他未列明建筑业",
            "TOP_ID": "E"
        },
        {
            "ID": "511",
            "CODE": "农业机械服务",
            "TOP_ID": "A"
        },
        {
            "ID": "5111",
            "CODE": "谷物、豆及薯类批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5112",
            "CODE": "种子批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5113",
            "CODE": "饲料批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5114",
            "CODE": "棉、麻批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5115",
            "CODE": "林业产品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5116",
            "CODE": "牲畜批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5119",
            "CODE": "其他农牧产品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "512",
            "CODE": "灌溉服务",
            "TOP_ID": "A"
        },
        {
            "ID": "5121",
            "CODE": "米、面制品及食用油批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5122",
            "CODE": "糕点、糖果及糖批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5123",
            "CODE": "果品、蔬菜批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5124",
            "CODE": "肉、禽、蛋、奶及水产品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5125",
            "CODE": "盐及调味品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5126",
            "CODE": "营养和保健品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5127",
            "CODE": "酒、饮料及茶叶批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5128",
            "CODE": "烟草制品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5129",
            "CODE": "其他食品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "513",
            "CODE": "农产品初加工服务",
            "TOP_ID": "A"
        },
        {
            "ID": "5131",
            "CODE": "纺织品、针织品及原料批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5132",
            "CODE": "服装批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5133",
            "CODE": "鞋帽批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5134",
            "CODE": "化妆品及卫生用品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5135",
            "CODE": "厨房、卫生间用具及日用杂货批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5136",
            "CODE": "灯具、装饰物品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5137",
            "CODE": "家用电器批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5139",
            "CODE": "其他家庭用品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5141",
            "CODE": "文具用品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5142",
            "CODE": "体育用品及器材批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5143",
            "CODE": "图书批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5144",
            "CODE": "报刊批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5145",
            "CODE": "音像制品及电子出版物批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5146",
            "CODE": "首饰、工艺品及收藏品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5149",
            "CODE": "其他文化用品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5151",
            "CODE": "西药批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5152",
            "CODE": "中药批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5153",
            "CODE": "医疗用品及器材批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5161",
            "CODE": "煤炭及制品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5162",
            "CODE": "石油及制品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5163",
            "CODE": "非金属矿及制品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5164",
            "CODE": "金属及金属矿批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5165",
            "CODE": "建材批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5166",
            "CODE": "化肥批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5167",
            "CODE": "农药批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5168",
            "CODE": "农用薄膜批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5169",
            "CODE": "其他化工产品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5171",
            "CODE": "农业机械批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5172",
            "CODE": "汽车批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5173",
            "CODE": "汽车零配件批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5174",
            "CODE": "摩托车及零配件批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5175",
            "CODE": "五金产品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5176",
            "CODE": "电气设备批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5177",
            "CODE": "计算机、软件及辅助设备批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5178",
            "CODE": "通讯及广播电视设备批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5179",
            "CODE": "其他机械设备及电子产品批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5181",
            "CODE": "贸易代理",
            "TOP_ID": "F"
        },
        {
            "ID": "5182",
            "CODE": "拍卖",
            "TOP_ID": "F"
        },
        {
            "ID": "5189",
            "CODE": "其他贸易经纪与代理",
            "TOP_ID": "F"
        },
        {
            "ID": "519",
            "CODE": "其他农业服务",
            "TOP_ID": "A"
        },
        {
            "ID": "5191",
            "CODE": "再生物资回收与批发",
            "TOP_ID": "F"
        },
        {
            "ID": "5199",
            "CODE": "其他未列明批发业",
            "TOP_ID": "F"
        },
        {
            "ID": "521",
            "CODE": "林业有害生物防治服务",
            "TOP_ID": "A"
        },
        {
            "ID": "5211",
            "CODE": "百货零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5212",
            "CODE": "超级市场零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5219",
            "CODE": "其他综合零售",
            "TOP_ID": "F"
        },
        {
            "ID": "522",
            "CODE": "森林防火服务",
            "TOP_ID": "A"
        },
        {
            "ID": "5221",
            "CODE": "粮油零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5222",
            "CODE": "糕点、面包零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5223",
            "CODE": "果品、蔬菜零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5224",
            "CODE": "肉、禽、蛋、奶及水产品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5225",
            "CODE": "营养和保健品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5226",
            "CODE": "酒、饮料及茶叶零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5227",
            "CODE": "烟草制品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5229",
            "CODE": "其他食品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "523",
            "CODE": "林产品初级加工服务",
            "TOP_ID": "A"
        },
        {
            "ID": "5231",
            "CODE": "纺织品及针织品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5232",
            "CODE": "服装零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5233",
            "CODE": "鞋帽零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5234",
            "CODE": "化妆品及卫生用品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5235",
            "CODE": "钟表、眼镜零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5236",
            "CODE": "箱、包零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5237",
            "CODE": "厨房用具及日用杂品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5238",
            "CODE": "自行车零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5239",
            "CODE": "其他日用品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5241",
            "CODE": "文具用品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5242",
            "CODE": "体育用品及器材零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5243",
            "CODE": "图书、报刊零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5244",
            "CODE": "音像制品及电子出版物零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5245",
            "CODE": "珠宝首饰零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5246",
            "CODE": "工艺美术品及收藏品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5247",
            "CODE": "乐器零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5248",
            "CODE": "照相器材零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5249",
            "CODE": "其他文化用品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5251",
            "CODE": "药品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5252",
            "CODE": "医疗用品及器材零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5261",
            "CODE": "汽车零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5262",
            "CODE": "汽车零配件零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5263",
            "CODE": "摩托车及零配件零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5264",
            "CODE": "机动车燃料零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5271",
            "CODE": "家用视听设备零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5272",
            "CODE": "日用家电设备零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5273",
            "CODE": "计算机、软件及辅助设备零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5274",
            "CODE": "通信设备零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5279",
            "CODE": "其他电子产品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5281",
            "CODE": "五金零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5282",
            "CODE": "灯具零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5283",
            "CODE": "家具零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5284",
            "CODE": "涂料零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5285",
            "CODE": "卫生洁具零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5286",
            "CODE": "木质装饰材料零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5287",
            "CODE": "陶瓷、石材装饰材料零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5289",
            "CODE": "其他室内装饰材料零售",
            "TOP_ID": "F"
        },
        {
            "ID": "529",
            "CODE": "其他林业服务",
            "TOP_ID": "A"
        },
        {
            "ID": "5291",
            "CODE": "货摊食品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5292",
            "CODE": "货摊纺织、服装及鞋零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5293",
            "CODE": "货摊日用品零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5294",
            "CODE": "互联网零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5295",
            "CODE": "邮购及电视、电话零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5296",
            "CODE": "旧货零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5297",
            "CODE": "生活用燃料零售",
            "TOP_ID": "F"
        },
        {
            "ID": "5299",
            "CODE": "其他未列明零售业",
            "TOP_ID": "F"
        },
        {
            "ID": "530",
            "CODE": "畜牧服务业",
            "TOP_ID": "A"
        },
        {
            "ID": "5310",
            "CODE": "铁路旅客运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5320",
            "CODE": "铁路货物运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5331",
            "CODE": "客运火车站",
            "TOP_ID": "G"
        },
        {
            "ID": "5332",
            "CODE": "货运火车站",
            "TOP_ID": "G"
        },
        {
            "ID": "5339",
            "CODE": "其他铁路运输辅助活动",
            "TOP_ID": "G"
        },
        {
            "ID": "540",
            "CODE": "渔业服务业",
            "TOP_ID": "A"
        },
        {
            "ID": "5411",
            "CODE": "公共电汽车客运",
            "TOP_ID": "G"
        },
        {
            "ID": "5412",
            "CODE": "城市轨道交通",
            "TOP_ID": "G"
        },
        {
            "ID": "5413",
            "CODE": "出租车客运",
            "TOP_ID": "G"
        },
        {
            "ID": "5419",
            "CODE": "其他城市公共交通运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5420",
            "CODE": "公路旅客运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5430",
            "CODE": "道路货物运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5441",
            "CODE": "客运汽车站",
            "TOP_ID": "G"
        },
        {
            "ID": "5442",
            "CODE": "公路管理与养护",
            "TOP_ID": "G"
        },
        {
            "ID": "5449",
            "CODE": "其他道路运输辅助活动",
            "TOP_ID": "G"
        },
        {
            "ID": "5511",
            "CODE": "海洋旅客运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5512",
            "CODE": "内河旅客运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5513",
            "CODE": "客运轮渡运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5521",
            "CODE": "远洋货物运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5522",
            "CODE": "沿海货物运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5523",
            "CODE": "内河货物运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5531",
            "CODE": "客运港口",
            "TOP_ID": "G"
        },
        {
            "ID": "5532",
            "CODE": "货运港口",
            "TOP_ID": "G"
        },
        {
            "ID": "5539",
            "CODE": "其他水上运输辅助活动",
            "TOP_ID": "G"
        },
        {
            "ID": "5611",
            "CODE": "航空旅客运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5612",
            "CODE": "航空货物运输",
            "TOP_ID": "G"
        },
        {
            "ID": "5620",
            "CODE": "通用航空服务",
            "TOP_ID": "G"
        },
        {
            "ID": "5631",
            "CODE": "机场",
            "TOP_ID": "G"
        },
        {
            "ID": "5632",
            "CODE": "空中交通管理",
            "TOP_ID": "G"
        },
        {
            "ID": "5639",
            "CODE": "其他航空运输辅助活动",
            "TOP_ID": "G"
        },
        {
            "ID": "5700",
            "CODE": "管道运输业",
            "TOP_ID": "G"
        },
        {
            "ID": "5810",
            "CODE": "装卸搬运",
            "TOP_ID": "G"
        },
        {
            "ID": "5821",
            "CODE": "货物运输代理",
            "TOP_ID": "G"
        },
        {
            "ID": "5822",
            "CODE": "旅客票务代理",
            "TOP_ID": "G"
        },
        {
            "ID": "5829",
            "CODE": "其他运输代理业",
            "TOP_ID": "G"
        },
        {
            "ID": "5911",
            "CODE": "谷物仓储",
            "TOP_ID": "G"
        },
        {
            "ID": "5912",
            "CODE": "棉花仓储",
            "TOP_ID": "G"
        },
        {
            "ID": "5919",
            "CODE": "其他农产品仓储",
            "TOP_ID": "G"
        },
        {
            "ID": "5990",
            "CODE": "其他仓储业",
            "TOP_ID": "G"
        },
        {
            "ID": "6010",
            "CODE": "邮政基本服务",
            "TOP_ID": "G"
        },
        {
            "ID": "6020",
            "CODE": "快递服务",
            "TOP_ID": "G"
        },
        {
            "ID": "610",
            "CODE": "烟煤和无烟煤开采洗选",
            "TOP_ID": "B"
        },
        {
            "ID": "6110",
            "CODE": "旅游饭店",
            "TOP_ID": "H"
        },
        {
            "ID": "6120",
            "CODE": "一般旅馆",
            "TOP_ID": "H"
        },
        {
            "ID": "6190",
            "CODE": "其他住宿业",
            "TOP_ID": "H"
        },
        {
            "ID": "620",
            "CODE": "褐煤开采洗选",
            "TOP_ID": "B"
        },
        {
            "ID": "6210",
            "CODE": "正餐服务",
            "TOP_ID": "H"
        },
        {
            "ID": "6220",
            "CODE": "快餐服务",
            "TOP_ID": "H"
        },
        {
            "ID": "6231",
            "CODE": "茶馆服务",
            "TOP_ID": "H"
        },
        {
            "ID": "6232",
            "CODE": "咖啡馆服务",
            "TOP_ID": "H"
        },
        {
            "ID": "6233",
            "CODE": "酒吧服务",
            "TOP_ID": "H"
        },
        {
            "ID": "6239",
            "CODE": "其他饮料及冷饮服务",
            "TOP_ID": "H"
        },
        {
            "ID": "6291",
            "CODE": "小吃服务",
            "TOP_ID": "H"
        },
        {
            "ID": "6292",
            "CODE": "餐饮配送服务",
            "TOP_ID": "H"
        },
        {
            "ID": "6299",
            "CODE": "其他未列明餐饮业",
            "TOP_ID": "H"
        },
        {
            "ID": "6311",
            "CODE": "固定电信服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6312",
            "CODE": "移动电信服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6319",
            "CODE": "其他电信服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6321",
            "CODE": "有线广播电视传输服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6322",
            "CODE": "无线广播电视传输服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6330",
            "CODE": "卫星传输服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6410",
            "CODE": "互联网接入及相关服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6420",
            "CODE": "互联网信息服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6490",
            "CODE": "其他互联网服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6510",
            "CODE": "软件开发",
            "TOP_ID": "I"
        },
        {
            "ID": "6520",
            "CODE": "信息系统集成服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6530",
            "CODE": "信息技术咨询服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6540",
            "CODE": "数据处理和存储服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6550",
            "CODE": "集成电路设计",
            "TOP_ID": "I"
        },
        {
            "ID": "6591",
            "CODE": "数字内容服务",
            "TOP_ID": "I"
        },
        {
            "ID": "6592",
            "CODE": "呼叫中心",
            "TOP_ID": "I"
        },
        {
            "ID": "6599",
            "CODE": "其他未列明信息技术服务业",
            "TOP_ID": "I"
        },
        {
            "ID": "6610",
            "CODE": "中央银行服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6620",
            "CODE": "货币银行服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6631",
            "CODE": "金融租赁服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6632",
            "CODE": "财务公司",
            "TOP_ID": "J"
        },
        {
            "ID": "6633",
            "CODE": "典当",
            "TOP_ID": "J"
        },
        {
            "ID": "6639",
            "CODE": "其他非货币银行服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6640",
            "CODE": "银行监管服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6711",
            "CODE": "证券市场管理服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6712",
            "CODE": "证券经纪交易服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6713",
            "CODE": "基金管理服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6721",
            "CODE": "期货市场管理服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6729",
            "CODE": "其他期货市场服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6730",
            "CODE": "证券期货监管服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6740",
            "CODE": "资本投资服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6790",
            "CODE": "其他资本市场服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6811",
            "CODE": "人寿保险",
            "TOP_ID": "J"
        },
        {
            "ID": "6812",
            "CODE": "健康和意外保险",
            "TOP_ID": "J"
        },
        {
            "ID": "6820",
            "CODE": "财产保险",
            "TOP_ID": "J"
        },
        {
            "ID": "6830",
            "CODE": "再保险",
            "TOP_ID": "J"
        },
        {
            "ID": "6840",
            "CODE": "养老金",
            "TOP_ID": "J"
        },
        {
            "ID": "6850",
            "CODE": "保险经纪与代理服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6860",
            "CODE": "保险监管服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6891",
            "CODE": "风险和损失评估",
            "TOP_ID": "J"
        },
        {
            "ID": "6899",
            "CODE": "其他未列明保险活动",
            "TOP_ID": "J"
        },
        {
            "ID": "690",
            "CODE": "其他煤炭采选",
            "TOP_ID": "B"
        },
        {
            "ID": "6910",
            "CODE": "金融信托与管理服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6920",
            "CODE": "控股公司服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6930",
            "CODE": "非金融机构支付服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6940",
            "CODE": "金融信息服务",
            "TOP_ID": "J"
        },
        {
            "ID": "6990",
            "CODE": "其他未列明金融业",
            "TOP_ID": "J"
        },
        {
            "ID": "7010",
            "CODE": "房地产开发经营",
            "TOP_ID": "K"
        },
        {
            "ID": "7020",
            "CODE": "物业管理",
            "TOP_ID": "K"
        },
        {
            "ID": "7030",
            "CODE": "房地产中介服务",
            "TOP_ID": "K"
        },
        {
            "ID": "7040",
            "CODE": "自有房地产经营活动",
            "TOP_ID": "K"
        },
        {
            "ID": "7090",
            "CODE": "其他房地产业",
            "TOP_ID": "K"
        },
        {
            "ID": "710",
            "CODE": "石油开采",
            "TOP_ID": "B"
        },
        {
            "ID": "7111",
            "CODE": "汽车租赁",
            "TOP_ID": "L"
        },
        {
            "ID": "7112",
            "CODE": "农业机械租赁",
            "TOP_ID": "L"
        },
        {
            "ID": "7113",
            "CODE": "建筑工程机械与设备租赁",
            "TOP_ID": "L"
        },
        {
            "ID": "7114",
            "CODE": "计算机及通讯设备租赁",
            "TOP_ID": "L"
        },
        {
            "ID": "7119",
            "CODE": "其他机械与设备租赁",
            "TOP_ID": "L"
        },
        {
            "ID": "7121",
            "CODE": "娱乐及体育设备出租",
            "TOP_ID": "L"
        },
        {
            "ID": "7122",
            "CODE": "图书出租",
            "TOP_ID": "L"
        },
        {
            "ID": "7123",
            "CODE": "音像制品出租",
            "TOP_ID": "L"
        },
        {
            "ID": "7129",
            "CODE": "其他文化及日用品出租",
            "TOP_ID": "L"
        },
        {
            "ID": "720",
            "CODE": "天然气开采",
            "TOP_ID": "B"
        },
        {
            "ID": "7211",
            "CODE": "企业总部管理",
            "TOP_ID": "L"
        },
        {
            "ID": "7212",
            "CODE": "投资与资产管理",
            "TOP_ID": "L"
        },
        {
            "ID": "7213",
            "CODE": "单位后勤管理服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7219",
            "CODE": "其他企业管理服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7221",
            "CODE": "律师及相关法律服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7222",
            "CODE": "公证服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7229",
            "CODE": "其他法律服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7231",
            "CODE": "会计、审计及税务服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7232",
            "CODE": "市场调查",
            "TOP_ID": "L"
        },
        {
            "ID": "7233",
            "CODE": "社会经济咨询",
            "TOP_ID": "L"
        },
        {
            "ID": "7239",
            "CODE": "其他专业咨询",
            "TOP_ID": "L"
        },
        {
            "ID": "7240",
            "CODE": "广告业",
            "TOP_ID": "L"
        },
        {
            "ID": "7250",
            "CODE": "知识产权服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7261",
            "CODE": "公共就业服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7262",
            "CODE": "职业中介服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7263",
            "CODE": "劳务派遣服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7269",
            "CODE": "其他人力资源服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7271",
            "CODE": "旅行社服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7272",
            "CODE": "旅游管理服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7279",
            "CODE": "其他旅行社相关服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7281",
            "CODE": "安全服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7282",
            "CODE": "安全系统监控服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7289",
            "CODE": "其他安全保护服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7291",
            "CODE": "市场管理",
            "TOP_ID": "L"
        },
        {
            "ID": "7292",
            "CODE": "会议及展览服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7293",
            "CODE": "包装服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7294",
            "CODE": "办公服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7295",
            "CODE": "信用服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7296",
            "CODE": "担保服务",
            "TOP_ID": "L"
        },
        {
            "ID": "7299",
            "CODE": "其他未列明商务服务业",
            "TOP_ID": "L"
        },
        {
            "ID": "7310",
            "CODE": "自然科学研究和试验发展",
            "TOP_ID": "M"
        },
        {
            "ID": "7320",
            "CODE": "工程和技术研究和试验发展",
            "TOP_ID": "M"
        },
        {
            "ID": "7330",
            "CODE": "农业科学研究和试验发展",
            "TOP_ID": "M"
        },
        {
            "ID": "7340",
            "CODE": "医学研究和试验发展",
            "TOP_ID": "M"
        },
        {
            "ID": "7350",
            "CODE": "社会人文科学研究",
            "TOP_ID": "M"
        },
        {
            "ID": "7410",
            "CODE": "气象服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7420",
            "CODE": "地震服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7430",
            "CODE": "海洋服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7440",
            "CODE": "测绘服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7450",
            "CODE": "质检技术服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7461",
            "CODE": "环境保护监测",
            "TOP_ID": "M"
        },
        {
            "ID": "7462",
            "CODE": "生态监测",
            "TOP_ID": "M"
        },
        {
            "ID": "7471",
            "CODE": "能源矿产地质勘查",
            "TOP_ID": "M"
        },
        {
            "ID": "7472",
            "CODE": "固体矿产地质勘查",
            "TOP_ID": "M"
        },
        {
            "ID": "7473",
            "CODE": "水、二氧化碳等矿产地质勘查",
            "TOP_ID": "M"
        },
        {
            "ID": "7474",
            "CODE": "基础地质勘查",
            "TOP_ID": "M"
        },
        {
            "ID": "7475",
            "CODE": "地质勘查技术服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7481",
            "CODE": "工程管理服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7482",
            "CODE": "工程勘察设计",
            "TOP_ID": "M"
        },
        {
            "ID": "7483",
            "CODE": "规划管理",
            "TOP_ID": "M"
        },
        {
            "ID": "7491",
            "CODE": "专业化设计服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7492",
            "CODE": "摄影扩印服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7493",
            "CODE": "兽医服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7499",
            "CODE": "其他未列明专业技术服务业",
            "TOP_ID": "M"
        },
        {
            "ID": "7511",
            "CODE": "农业技术推广服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7512",
            "CODE": "生物技术推广服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7513",
            "CODE": "新材料技术推广服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7514",
            "CODE": "节能技术推广服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7519",
            "CODE": "其他技术推广服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7520",
            "CODE": "科技中介服务",
            "TOP_ID": "M"
        },
        {
            "ID": "7590",
            "CODE": "其他科技推广和应用服务业",
            "TOP_ID": "M"
        },
        {
            "ID": "7610",
            "CODE": "防洪除涝设施管理",
            "TOP_ID": "N"
        },
        {
            "ID": "7620",
            "CODE": "水资源管理",
            "TOP_ID": "N"
        },
        {
            "ID": "7630",
            "CODE": "天然水收集与分配",
            "TOP_ID": "N"
        },
        {
            "ID": "7640",
            "CODE": "水文服务",
            "TOP_ID": "N"
        },
        {
            "ID": "7690",
            "CODE": "其他水利管理业",
            "TOP_ID": "N"
        },
        {
            "ID": "7711",
            "CODE": "自然保护区管理",
            "TOP_ID": "N"
        },
        {
            "ID": "7712",
            "CODE": "野生动物保护",
            "TOP_ID": "N"
        },
        {
            "ID": "7713",
            "CODE": "野生植物保护",
            "TOP_ID": "N"
        },
        {
            "ID": "7719",
            "CODE": "其他自然保护",
            "TOP_ID": "N"
        },
        {
            "ID": "7721",
            "CODE": "水污染治理",
            "TOP_ID": "N"
        },
        {
            "ID": "7722",
            "CODE": "大气污染治理",
            "TOP_ID": "N"
        },
        {
            "ID": "7723",
            "CODE": "固体废物治理",
            "TOP_ID": "N"
        },
        {
            "ID": "7724",
            "CODE": "危险废物治理",
            "TOP_ID": "N"
        },
        {
            "ID": "7725",
            "CODE": "放射性废物治理",
            "TOP_ID": "N"
        },
        {
            "ID": "7729",
            "CODE": "其他污染治理",
            "TOP_ID": "N"
        },
        {
            "ID": "7810",
            "CODE": "市政设施管理",
            "TOP_ID": "N"
        },
        {
            "ID": "7820",
            "CODE": "环境卫生管理",
            "TOP_ID": "N"
        },
        {
            "ID": "7830",
            "CODE": "城乡市容管理",
            "TOP_ID": "N"
        },
        {
            "ID": "7840",
            "CODE": "绿化管理",
            "TOP_ID": "N"
        },
        {
            "ID": "7851",
            "CODE": "公园管理",
            "TOP_ID": "N"
        },
        {
            "ID": "7852",
            "CODE": "游览景区管理",
            "TOP_ID": "N"
        },
        {
            "ID": "7910",
            "CODE": "家庭服务",
            "TOP_ID": "O"
        },
        {
            "ID": "7920",
            "CODE": "托儿所服务",
            "TOP_ID": "O"
        },
        {
            "ID": "7930",
            "CODE": "洗染服务",
            "TOP_ID": "O"
        },
        {
            "ID": "7940",
            "CODE": "理发及美容服务",
            "TOP_ID": "O"
        },
        {
            "ID": "7950",
            "CODE": "洗浴服务",
            "TOP_ID": "O"
        },
        {
            "ID": "7960",
            "CODE": "保健服务",
            "TOP_ID": "O"
        },
        {
            "ID": "7970",
            "CODE": "婚姻服务",
            "TOP_ID": "O"
        },
        {
            "ID": "7980",
            "CODE": "殡葬服务",
            "TOP_ID": "O"
        },
        {
            "ID": "7990",
            "CODE": "其他居民服务业",
            "TOP_ID": "O"
        },
        {
            "ID": "8011",
            "CODE": "汽车修理与维护",
            "TOP_ID": "O"
        },
        {
            "ID": "8012",
            "CODE": "摩托车修理与维护",
            "TOP_ID": "O"
        },
        {
            "ID": "8021",
            "CODE": "计算机和辅助设备修理",
            "TOP_ID": "O"
        },
        {
            "ID": "8022",
            "CODE": "通讯设备修理",
            "TOP_ID": "O"
        },
        {
            "ID": "8029",
            "CODE": "其他办公设备维修",
            "TOP_ID": "O"
        },
        {
            "ID": "8031",
            "CODE": "家用电子产品修理",
            "TOP_ID": "O"
        },
        {
            "ID": "8032",
            "CODE": "日用电器修理",
            "TOP_ID": "O"
        },
        {
            "ID": "8091",
            "CODE": "自行车修理",
            "TOP_ID": "O"
        },
        {
            "ID": "8092",
            "CODE": "鞋和皮革修理",
            "TOP_ID": "O"
        },
        {
            "ID": "8093",
            "CODE": "家具和相关物品修理",
            "TOP_ID": "O"
        },
        {
            "ID": "8099",
            "CODE": "其他未列明日用产品修理业",
            "TOP_ID": "O"
        },
        {
            "ID": "810",
            "CODE": "铁矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "8111",
            "CODE": "建筑物清洁服务",
            "TOP_ID": "O"
        },
        {
            "ID": "8119",
            "CODE": "其他清洁服务",
            "TOP_ID": "O"
        },
        {
            "ID": "8190",
            "CODE": "其他未列明服务业",
            "TOP_ID": "O"
        },
        {
            "ID": "820",
            "CODE": "锰矿、铬矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "8210",
            "CODE": "学前教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8221",
            "CODE": "普通小学教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8222",
            "CODE": "成人小学教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8231",
            "CODE": "普通初中教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8232",
            "CODE": "职业初中教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8233",
            "CODE": "成人初中教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8234",
            "CODE": "普通高中教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8235",
            "CODE": "成人高中教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8236",
            "CODE": "中等职业学校教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8241",
            "CODE": "普通高等教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8242",
            "CODE": "成人高等教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8250",
            "CODE": "特殊教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8291",
            "CODE": "职业技能培训",
            "TOP_ID": "P"
        },
        {
            "ID": "8292",
            "CODE": "体校及体育培训",
            "TOP_ID": "P"
        },
        {
            "ID": "8293",
            "CODE": "文化艺术培训",
            "TOP_ID": "P"
        },
        {
            "ID": "8294",
            "CODE": "教育辅助服务",
            "TOP_ID": "P"
        },
        {
            "ID": "8299",
            "CODE": "其他未列明教育",
            "TOP_ID": "P"
        },
        {
            "ID": "8311",
            "CODE": "综合医院",
            "TOP_ID": "Q"
        },
        {
            "ID": "8312",
            "CODE": "中医医院",
            "TOP_ID": "Q"
        },
        {
            "ID": "8313",
            "CODE": "中西医结合医院",
            "TOP_ID": "Q"
        },
        {
            "ID": "8314",
            "CODE": "民族医院",
            "TOP_ID": "Q"
        },
        {
            "ID": "8315",
            "CODE": "专科医院",
            "TOP_ID": "Q"
        },
        {
            "ID": "8316",
            "CODE": "疗养院",
            "TOP_ID": "Q"
        },
        {
            "ID": "8321",
            "CODE": "社区卫生服务中心（站）",
            "TOP_ID": "Q"
        },
        {
            "ID": "8322",
            "CODE": "街道卫生院",
            "TOP_ID": "Q"
        },
        {
            "ID": "8323",
            "CODE": "乡镇卫生院",
            "TOP_ID": "Q"
        },
        {
            "ID": "8330",
            "CODE": "门诊部（所）",
            "TOP_ID": "Q"
        },
        {
            "ID": "8340",
            "CODE": "计划生育技术服务活动",
            "TOP_ID": "Q"
        },
        {
            "ID": "8350",
            "CODE": "妇幼保健院（所、站）",
            "TOP_ID": "Q"
        },
        {
            "ID": "8360",
            "CODE": "专科疾病防治院（所、站）",
            "TOP_ID": "Q"
        },
        {
            "ID": "8370",
            "CODE": "疾病预防控制中心",
            "TOP_ID": "Q"
        },
        {
            "ID": "8390",
            "CODE": "其他卫生活动",
            "TOP_ID": "Q"
        },
        {
            "ID": "8411",
            "CODE": "干部休养所",
            "TOP_ID": "Q"
        },
        {
            "ID": "8412",
            "CODE": "护理机构服务",
            "TOP_ID": "Q"
        },
        {
            "ID": "8413",
            "CODE": "精神康复服务",
            "TOP_ID": "Q"
        },
        {
            "ID": "8414",
            "CODE": "老年人、残疾人养护服务",
            "TOP_ID": "Q"
        },
        {
            "ID": "8415",
            "CODE": "孤残儿童收养和庇护服务",
            "TOP_ID": "Q"
        },
        {
            "ID": "8419",
            "CODE": "其他提供住宿社会救助",
            "TOP_ID": "Q"
        },
        {
            "ID": "8421",
            "CODE": "社会看护与帮助服务",
            "TOP_ID": "Q"
        },
        {
            "ID": "8429",
            "CODE": "其他不提供住宿社会工作",
            "TOP_ID": "Q"
        },
        {
            "ID": "8510",
            "CODE": "新闻业",
            "TOP_ID": "R"
        },
        {
            "ID": "8521",
            "CODE": "图书出版",
            "TOP_ID": "R"
        },
        {
            "ID": "8522",
            "CODE": "报纸出版",
            "TOP_ID": "R"
        },
        {
            "ID": "8523",
            "CODE": "期刊出版",
            "TOP_ID": "R"
        },
        {
            "ID": "8524",
            "CODE": "音像制品出版",
            "TOP_ID": "R"
        },
        {
            "ID": "8525",
            "CODE": "电子出版物出版",
            "TOP_ID": "R"
        },
        {
            "ID": "8529",
            "CODE": "其他出版业",
            "TOP_ID": "R"
        },
        {
            "ID": "8610",
            "CODE": "广播",
            "TOP_ID": "R"
        },
        {
            "ID": "8620",
            "CODE": "电视",
            "TOP_ID": "R"
        },
        {
            "ID": "8630",
            "CODE": "电影和影视节目制作",
            "TOP_ID": "R"
        },
        {
            "ID": "8640",
            "CODE": "电影和影视节目发行",
            "TOP_ID": "R"
        },
        {
            "ID": "8650",
            "CODE": "电影放映",
            "TOP_ID": "R"
        },
        {
            "ID": "8660",
            "CODE": "录音制作",
            "TOP_ID": "R"
        },
        {
            "ID": "8710",
            "CODE": "文艺创作与表演",
            "TOP_ID": "R"
        },
        {
            "ID": "8720",
            "CODE": "艺术表演场馆",
            "TOP_ID": "R"
        },
        {
            "ID": "8731",
            "CODE": "图书馆",
            "TOP_ID": "R"
        },
        {
            "ID": "8732",
            "CODE": "档案馆",
            "TOP_ID": "R"
        },
        {
            "ID": "8740",
            "CODE": "文物及非物质文化遗产保护",
            "TOP_ID": "R"
        },
        {
            "ID": "8750",
            "CODE": "博物馆",
            "TOP_ID": "R"
        },
        {
            "ID": "8760",
            "CODE": "烈士陵园、纪念馆",
            "TOP_ID": "R"
        },
        {
            "ID": "8770",
            "CODE": "群众文化活动",
            "TOP_ID": "R"
        },
        {
            "ID": "8790",
            "CODE": "其他文化艺术业",
            "TOP_ID": "R"
        },
        {
            "ID": "8810",
            "CODE": "体育组织",
            "TOP_ID": "R"
        },
        {
            "ID": "8820",
            "CODE": "体育场馆",
            "TOP_ID": "R"
        },
        {
            "ID": "8830",
            "CODE": "休闲健身活动",
            "TOP_ID": "R"
        },
        {
            "ID": "8890",
            "CODE": "其他体育",
            "TOP_ID": "R"
        },
        {
            "ID": "890",
            "CODE": "其他黑色金属矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "8911",
            "CODE": "歌舞厅娱乐活动",
            "TOP_ID": "R"
        },
        {
            "ID": "8912",
            "CODE": "电子游艺厅娱乐活动",
            "TOP_ID": "R"
        },
        {
            "ID": "8913",
            "CODE": "网吧活动",
            "TOP_ID": "R"
        },
        {
            "ID": "8919",
            "CODE": "其他室内娱乐活动",
            "TOP_ID": "R"
        },
        {
            "ID": "8920",
            "CODE": "游乐园",
            "TOP_ID": "R"
        },
        {
            "ID": "8930",
            "CODE": "彩票活动",
            "TOP_ID": "R"
        },
        {
            "ID": "8941",
            "CODE": "文化娱乐经纪人",
            "TOP_ID": "R"
        },
        {
            "ID": "8942",
            "CODE": "体育经纪人",
            "TOP_ID": "R"
        },
        {
            "ID": "8949",
            "CODE": "其他文化艺术经纪代理",
            "TOP_ID": "R"
        },
        {
            "ID": "8990",
            "CODE": "其他娱乐业",
            "TOP_ID": "R"
        },
        {
            "ID": "9000",
            "CODE": "中国共产党机关",
            "TOP_ID": "S"
        },
        {
            "ID": "911",
            "CODE": "铜矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "9110",
            "CODE": "国家权力机构",
            "TOP_ID": "S"
        },
        {
            "ID": "912",
            "CODE": "铅锌矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "9121",
            "CODE": "综合事务管理机构",
            "TOP_ID": "S"
        },
        {
            "ID": "9122",
            "CODE": "对外事务管理机构",
            "TOP_ID": "S"
        },
        {
            "ID": "9123",
            "CODE": "公共安全管理机构",
            "TOP_ID": "S"
        },
        {
            "ID": "9124",
            "CODE": "社会事务管理机构",
            "TOP_ID": "S"
        },
        {
            "ID": "9125",
            "CODE": "经济事务管理机构",
            "TOP_ID": "S"
        },
        {
            "ID": "9126",
            "CODE": "行政监督检查机构",
            "TOP_ID": "S"
        },
        {
            "ID": "913",
            "CODE": "镍钴矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "9131",
            "CODE": "人民法院",
            "TOP_ID": "S"
        },
        {
            "ID": "9132",
            "CODE": "人民检察院",
            "TOP_ID": "S"
        },
        {
            "ID": "914",
            "CODE": "锡矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "915",
            "CODE": "锑矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "916",
            "CODE": "铝矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "917",
            "CODE": "镁矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "919",
            "CODE": "其他常用有色金属矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "9190",
            "CODE": "其他国家机构",
            "TOP_ID": "S"
        },
        {
            "ID": "921",
            "CODE": "金矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "9210",
            "CODE": "人民政协",
            "TOP_ID": "S"
        },
        {
            "ID": "922",
            "CODE": "银矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "9220",
            "CODE": "民主党派",
            "TOP_ID": "S"
        },
        {
            "ID": "929",
            "CODE": "其他贵金属矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "9300",
            "CODE": "社会保障",
            "TOP_ID": "S"
        },
        {
            "ID": "931",
            "CODE": "钨钼矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "932",
            "CODE": "稀土金属矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "933",
            "CODE": "放射性金属矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "939",
            "CODE": "其他稀有金属矿采选",
            "TOP_ID": "B"
        },
        {
            "ID": "9411",
            "CODE": "工会",
            "TOP_ID": "S"
        },
        {
            "ID": "9412",
            "CODE": "妇联",
            "TOP_ID": "S"
        },
        {
            "ID": "9413",
            "CODE": "共青团",
            "TOP_ID": "S"
        },
        {
            "ID": "9419",
            "CODE": "其他群众团体",
            "TOP_ID": "S"
        },
        {
            "ID": "9421",
            "CODE": "专业性团体",
            "TOP_ID": "S"
        },
        {
            "ID": "9422",
            "CODE": "行业性团体",
            "TOP_ID": "S"
        },
        {
            "ID": "9429",
            "CODE": "其他社会团体",
            "TOP_ID": "S"
        },
        {
            "ID": "9430",
            "CODE": "基金会",
            "TOP_ID": "S"
        },
        {
            "ID": "9440",
            "CODE": "宗教组织",
            "TOP_ID": "S"
        },
        {
            "ID": "9510",
            "CODE": "社区自治组织",
            "TOP_ID": "S"
        },
        {
            "ID": "9520",
            "CODE": "村民自治组织",
            "TOP_ID": "S"
        },
        {
            "ID": "9600",
            "CODE": "国际组织",
            "TOP_ID": "T"
        }
    ]
}